/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsIcCpuCoresFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsIcCpuCoresFormat = ClosedEnum<
  typeof GetApiV3MetricsIcCpuCoresFormat
>;

export type GetApiV3MetricsIcCpuCoresRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsIcCpuCoresFormat | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsIcCpuCoresFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsIcCpuCoresFormat
> = z.nativeEnum(GetApiV3MetricsIcCpuCoresFormat);

/** @internal */
export const GetApiV3MetricsIcCpuCoresFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsIcCpuCoresFormat
> = GetApiV3MetricsIcCpuCoresFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIcCpuCoresFormat$ {
  /** @deprecated use `GetApiV3MetricsIcCpuCoresFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsIcCpuCoresFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIcCpuCoresFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MetricsIcCpuCoresFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsIcCpuCoresRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsIcCpuCoresRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsIcCpuCoresFormat$inboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/** @internal */
export type GetApiV3MetricsIcCpuCoresRequest$Outbound = {
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsIcCpuCoresRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsIcCpuCoresRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsIcCpuCoresRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsIcCpuCoresFormat$outboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIcCpuCoresRequest$ {
  /** @deprecated use `GetApiV3MetricsIcCpuCoresRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsIcCpuCoresRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIcCpuCoresRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MetricsIcCpuCoresRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsIcCpuCoresRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsIcCpuCoresRequest$Outbound;
}

export function getApiV3MetricsIcCpuCoresRequestToJSON(
  getApiV3MetricsIcCpuCoresRequest: GetApiV3MetricsIcCpuCoresRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsIcCpuCoresRequest$outboundSchema.parse(
      getApiV3MetricsIcCpuCoresRequest,
    ),
  );
}

export function getApiV3MetricsIcCpuCoresRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsIcCpuCoresRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3MetricsIcCpuCoresRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsIcCpuCoresRequest' from JSON`,
  );
}
